import { observer } from "mobx-react";
import { useEffect, useState } from "react";

import { KeyPhrasesPopup } from "pages/Projects/components/ProjectPropertyColumn/BotColumns/KeyPhrasesPopup/KeyPhrasesPopup";
import Button from "components/UI/Button/Button";

import AppStore from "AppStore";
import popupStore from "components/Popup/PopupStore";

import "./ProjectDraftsInfo.scss";

const ProjectDraftsInfo = observer(({ project }) => {
  const [showKeyPhrasesPopup, setShowKeyPhrasesPopup] = useState(false);

  if (!project || !project.activities) return null;

  const hasActiveActivities = project.activities.some(activity => activity.count > 0);
  
  const hasExtras = project.extras && (
    (typeof project.extras === 'string' && project.extras.trim().length > 0) ||
    (typeof project.extras === 'object' && Object.keys(project.extras).length > 0)
  );
  
  const hasSearchPhrases = project.searchPhrases && project.searchPhrases !== "—";
  
  if (!hasActiveActivities && !hasExtras && !hasSearchPhrases) return null;

  const market = AppStore.marketsMap[project.type.toLowerCase()];
  
  const getActivityTitle = (activityType) => {
    try {
      const actionFromMap = market?.actionsMap?.[activityType];
      
      if (!actionFromMap) {
        return String(activityType || 'Unknown');
      }
      
      if (typeof actionFromMap === 'string') {
        return actionFromMap;
      }
      
      if (typeof actionFromMap === 'object' && actionFromMap !== null) {
        if (actionFromMap.title && typeof actionFromMap.title === 'string') {
          return actionFromMap.title;
        }
        
        return String(activityType || 'Unknown');
      }
      
      return String(actionFromMap);
      
    } catch (error) {
      return String(activityType || 'Unknown');
    }
  };

  const renderActivities = () => {
    const activeActivities = project.activities.filter(activity => activity.count > 0);
    
    return activeActivities.map((activity, index) => {
      const activityTitle = getActivityTitle(activity.type);
      const hasAdditionalInfo = activity.info || activity.warranty;
      
      return (
        <div key={index} className="project-activities-info__activity-item">
          <div className="project-activities-info__activity-main">
            <span className="project-activities-info__activity-name">
              {typeof activityTitle === 'string' ? activityTitle : JSON.stringify(activityTitle)}
            </span>
            <span className="project-activities-info__activity-count">
              {activity.count}
            </span>
          </div>
          {hasAdditionalInfo && (
            <div className="project-activities-info__activity-details">
              {activity.warranty && (
                <div className="project-activities-info__activity-warranty">
                  <span className="project-activities-info__warranty-badge">Гарантия</span>
                </div>
              )}
            </div>
          )}
        </div>
      );
    });
  };

  const renderExtras = () => {
    if (!hasExtras) return null;

    if (typeof project.extras === 'string') {
      const extrasText = project.extras.trim();
      
      return (
        <div className="project-activities-info__extras">
          <div className="project-activities-info__extra-item project-activities-info__extra-instructions">
            <span className="project-activities-info__extra-label">
              Инструкции:
            </span>
            <div className="project-activities-info__extra-value project-activities-info__extra-text">
              {extrasText.split('\n').map((line, index) => (
                <div key={index} className="project-activities-info__instruction-line">
                  {line}
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    const extrasLabels = {
      musician: "Исполнитель",
      albumTitle: "Альбом", 
      trackTitle: "Трек",
      comment: "Текст отзыва",
      customService: "Услуга для оценки",
      photosUrl: "Источник скриншотов",
    };

    return (
      <div className="project-activities-info__extras">
        {Object.entries(project.extras).map(([key, value]) => {
          if (!value) return null;       
          if (typeof value === 'object') return null;
          
          return (
            <div key={key} className="project-activities-info__extra-item">
              <span className="project-activities-info__extra-label">
                {extrasLabels[key] || key}:
              </span>
              <span className="project-activities-info__extra-value">
                {String(value)}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const handleShowKeyPhrases = () => {
    popupStore.open("key-phrases"); 
    setShowKeyPhrasesPopup(true);
  };

  const handleCloseKeyPhrases = () => {
    popupStore.close();
    setShowKeyPhrasesPopup(false);
  };

  useEffect(() => {
    if (!popupStore.isOpen || popupStore.modalType !== "key-phrases") {
      setShowKeyPhrasesPopup(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popupStore.isOpen, popupStore.modalType]);

  return (
    <div className="project-activities-info">
      {hasActiveActivities && (
        <div className="project-activities-info__activities">
          <div className="project-activities-info__activities-list">
            {renderActivities()}
          </div>
        </div>
      )}
      
      {renderExtras()}

      {hasSearchPhrases && (
        <div className="project-activities-info__key-phrases">
          <Button 
            className="project-activities-info__key-phrases-button"
            title="Показать все ключевые запросы" 
            onClick={handleShowKeyPhrases}
          />
        </div>
      )}
      
      
      {showKeyPhrasesPopup && (
        <KeyPhrasesPopup 
          project={project} 
          phrases={Array.isArray(project.searchPhrases) ? project.searchPhrases : project.searchPhrases.split('\n')} 
          onClose={handleCloseKeyPhrases}
        />
      )}
    </div>
  );
});

export default ProjectDraftsInfo;